export enum EventTypeEnum {
	BLIND_DATING = 'BLIND_DATING',
}

export enum EventStatusEnum {
	SCHEDULED = 'SCHEDULED',
	LIVE = 'LIVE',
	ENDED = 'ENDED',
}
